import { all, put, call, takeLatest } from 'redux-saga/effects'

import * as SignupTypes from 'Redux/Types/SignupTypes'
import * as SignupActions from 'Redux/Actions/SignupActions'

import {
  getCountries as getCountriesApi,
  getIndustries as getIndustriesApi,
  getRequestPromoCode,
} from 'Service/Api'

export function* getFormData() {
  try {
    const {
      countries: { data: countries },
      industries: { data: industries },
    } = yield all({
      countries: call(getCountriesApi),
      industries: call(getIndustriesApi),
    })
    const payload = { countries, industries }
    yield put(SignupActions.getFormDataSucceeded(payload))
  } catch (errors) {
    yield put(SignupActions.getFormDataFailed(errors))
  }
}

function* getRequestPromoCodeWorker({ payload }) {
  try {
    const response = yield call(getRequestPromoCode, payload)
    yield put(SignupActions.getRequestPromoCodeSucceeded(response.data))
  } catch (error) {
    yield put(SignupActions.getRequestPromoCodeFailed(error))
  }
}

export default function* signupFormSaga() {
  yield takeLatest(SignupTypes.GET_FORM_DATA, getFormData)
  yield takeLatest(SignupTypes.GET_REQUEST_PROMO_CODE, getRequestPromoCodeWorker)
}
